import { isPlatformBrowser } from '@angular/common';
import { Directive, ElementRef, Input, AfterViewInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { gsap } from 'gsap';

@Directive({
  selector: '[appGsapSplitTextOnScroll]',
  standalone: true,
})
export class GsapSplitTextOnScrollDirective implements AfterViewInit, OnDestroy {
  @Input('appGsapSplitTextOnScroll') delay: number = 0;
  
  private observer?: IntersectionObserver;
  private tl?: gsap.core.Tween;
  
  constructor(private el: ElementRef, @Inject(PLATFORM_ID) private platformId: Object) {}

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const element = this.el.nativeElement;

    if (element.dataset['animated'] === 'true') return;

    gsap.set(element, { opacity: 0 }); 

    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.animateElement(element);
            observer.unobserve(element); 
          }
        });
      },
      {
        threshold: 0.3,
      }
    );

    this.observer.observe(element);
  }

  private animateElement(element: HTMLElement): void {
    if (element.dataset['animated'] === 'true') return;
    element.dataset['animated'] = 'true';

    this.tl = gsap.fromTo(element,
      { opacity: 0, y: 50 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.out",
        delay: this.delay,
      }
    );
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
    if (this.tl) {
      this.tl.kill();
    }  
  }
}